export function ManageData() {
  return (
    <p>
      You can access and manage your data in your account settings or by sending a request to contact@cityfalcon.ai.
      <br />
      <br />
      Users may request the deletion of their data by writing to contact@cityfalcon.ai with the account to delete. To protect users from malicious deletion, the originating email address must match the account email address. If access is no longer possible, requesters must provide another proof of ownership of the account to be deleted. Users who have signed up through other means, such as Facebook or Twitter, should contact us from those accounts:
      <br />
      <br />
      <ul>
        <li>
          Twitter -
          {' '}
          <a href="https://twitter.com/cityfalcon" target="_blank" rel="noreferrer">
            https://twitter.com/cityfalcon
          </a>
        </li>
        <li>
          Facebook -
          {' '}
          <a href="https://www.facebook.com/cityfalconfollow" target="_blank" rel="noreferrer">
            https://www.facebook.com/cityfalconfollow
          </a>
        </li>
        <li>
          LinkedIn -
          {' '}
          <a href="https://www.linkedin.com/company/cityfalcon" target="_blank" rel="noreferrer">
            https://www.linkedin.com/company/cityfalcon
          </a>
        </li>
      </ul>
    </p>
  );
}

export default ManageData;
